import { render, staticRenderFns } from "./LendingPage_MeetingPlace.vue?vue&type=template&id=b97020d8&scoped=true&"
import script from "./LendingPage_MeetingPlace.vue?vue&type=script&lang=js&"
export * from "./LendingPage_MeetingPlace.vue?vue&type=script&lang=js&"
import style0 from "./LendingPage_MeetingPlace.vue?vue&type=style&index=0&id=b97020d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97020d8",
  null
  
)

export default component.exports